// extracted by mini-css-extract-plugin
export var video = "video-module--video--1rlJI";
export var video__wrap = "video-module--video__wrap--1KbhY";
export var video__video = "video-module--video__video--3v3qb";
export var video__content = "video-module--video__content--32Pht";